<template>
  <Modal
    v-if="dialog"
    :dialog.sync="dialog"
    title="Выберите шаблон"
    contentClass="esh-theme adminModal"
    :width="1280"
  >
    <template #body>
      <v-card outlined>
        <v-card-text>
          <v-row>
            <v-col md="4">
              <v-text-field
                v-model="filter.search"
                placeholder="Поиск по названию"
                dense
              />
            </v-col>
          </v-row>
          <v-row v-if="totalTemplates">
            <v-col md="4" v-for="template in templates" :key="template.id">
              <v-card
                active-class="active-card"
                :class="{ 'active-card': selectedTemplate && selectedTemplate.id === template.id }"
                @click="toggleSelect(template)"
                outlined
              >
                <v-list-item one-line>
                  <v-list-item-content>
                    <div class="overline mb-4">Создан: {{ template.created_at | dateTime }}</div>
                    <v-list-item-title class="headline mb-1">{{ template.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-card-text>
                  <div class="text--primary">
                    {{ getShortText(template.template) }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="12">
              <v-pagination
                v-model="paginator.page"
                :length="paginator.length"
              ></v-pagination>
            </v-col>
          </v-row>
          <div v-else>
            <v-alert outlined type="info" dense class="mt-3">Шаблоны массовой рассылки не созданы</v-alert>
          </div>
        </v-card-text>
      </v-card>
    </template>
    <template #actions>
      <v-row align="center" justify="end" no-gutters>
        <v-btn
          :disabled="!selectedTemplate"
          @click="onSelect"
        >
          <v-icon left>done_all</v-icon> Выбрать шаблон
        </v-btn>
        </v-row>
    </template>
  </Modal>
</template>
<style scoped>
.active-card{
  border: 1px solid rgba(0, 0, 0)!important;
}
</style>

<script>
import { debounce } from 'lodash'
import { BASE } from '@/config'
import { Modal } from '@/components/common'
import { GET_NOTIFICATION_MASS_TEMPLATES } from '@/requests/superadmin'

export default {
  name: 'TemplatesMassSelectorModal',
  components: {
    Modal
  },
  props: {
    show: {
      props: Boolean,
      default: false
    }
  },
  data() {
    return {
      shortTextLength: 250,
      selectedTemplate: null,
      templates: [],
      totalTemplates: 0,
      offset: 0,
      templatesPerPage: 12,
      filter: {
        search: ''
      },
      paginator: {
        page: 1,
        length: 0
      }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      }
    }
  },
  watch: {
    show: function(state) {
      if (state) {
        this.getDataFromFirstPage()
        this.filter.search = ''
        this.selectedTemplate = null
      }
    },
    'paginator.page': function(value) {
      this.offset = (value - 1) * this.templatesPerPage
      this.getData()
    },
    totalTemplates: function(value) {
      this.paginator.length = Math.ceil(value / this.templatesPerPage)
    },
    'filter.search': function(state, prevState) {
      if (state.length > prevState.length && state.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchTemplates()
      } else if (state.length < prevState.length && prevState.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchTemplates()
      }
    }
  },
  methods: {
    onSelect() {
      this.$emit('select', this.selectedTemplate)
      this.$emit('update:dialog', false)
      this.dialog = false
    },
    toggleSelect(template) {
      if (this.selectedTemplate) {
        this.selectedTemplate = this.selectedTemplate.id !== template.id ? template : null
      } else {
        this.selectedTemplate = template
      }
    },
    getShortText(text) {
      return text.length >= this.shortTextLength ? text.substring(0, this.shortTextLength) + '...' : text
    },
    searchTemplates: debounce(function() {
      this.getDataFromFirstPage()
    }, 300),
    getDataFromFirstPage() {
      this.page = 1
      this.offset = 0
      this.getData()
    },
    async getData() {
      try {
        const { data: { results, count } } = await GET_NOTIFICATION_MASS_TEMPLATES({
          limit: this.templatesPerPage,
          offset: this.offset,
          name: this.filter.search.length >= BASE.SEARCH_MIN_LETTERS ? this.filter.search : ''
        })

        this.totalTemplates = count
        this.templates = results
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить шаблоны массовой рассылки'
        })
      }
    }
  }
}
</script>